import React from 'react';
import { FunctionField } from 'admin-on-rest/lib/mui'

const render = record => record.basket.length;

const NbItemsField = (props) => <FunctionField {...props} render={render} />;

NbItemsField.defaultProps = {
    label: 'Nb Items',
    style: { textAlign: 'right' },
    headerStyle: { textAlign: 'right' },
};

export default NbItemsField;



// WEBPACK FOOTER //
// ./src/commands/NbItemsField.js